import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedComics() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-2">千万读者好评的精选韩漫</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="normal" />
          ))}
        </div>
      </div>
    </section>
  );
}